import React from 'react';
import { Redirect } from 'react-router';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import queryString from 'query-string';
import get from 'lodash/get';

import UserSettingsHeader from 'rebook/apps/users/components/UserSettingsHeader';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import { URLS } from 'rebook/apps/base/constants';
import { USER_SETTINGS_SUCCESS_MESSAGES, USER_SETTINGS_ERROR_MESSAGES } from 'rebook/apps/users/constants';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as UserActions from 'rebook/apps/users/actions/UserActions';

import UserSettingsAvatar from './UserSettingsAvatar';
import UserSettingsPersonalData from './UserSettingsPersonalData';
import UserSettingsPassword from './UserSettingsPassword';
import UserSettingsEmail from './UserSettingsEmail';
import UserSettingsSocialNetworks from './UserSettingsSocialNetworks';
import UserSettingsLitres from './UserSettingsLitres';
import styles from './style.scss';


class UserSettingsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unboundIsLoading: false,
    };
  }

  componentWillMount() {
    const { location } = this.props;
    this.props.SeoActions.setData({
      title: 'Настройки вашего профиля и история покупок',
    });
    const changeEmail = get(queryString.parse(location.search), 'change_email', null);
    if (changeEmail === '0') {
      this.props.NotificationActions.pop(USER_SETTINGS_SUCCESS_MESSAGES.USER_EMAIL_UPDATED, 'success');
    }
    if (changeEmail === '1') {
      this.props.NotificationActions.pop(USER_SETTINGS_ERROR_MESSAGES.EMAIL_CHANGING_ERROR, 'error');
    }
    const message = get(queryString.parse(location.search), 'message', null);
    if (message) {
      this.props.NotificationActions.pop(message, 'error');
    };
  }

  unbindSocialNetwork(e, provider) {
    e.preventDefault();
    const { social_auth: socialAuth } = this.props.user;
    const socialAccount = socialAuth.filter((item) => item.provider === provider);
    if (get(socialAccount, 'length', 0) === 0) {
      return;
    }
    this.setState({ unboundIsLoading: true });
    this.props.UserActions.unbindSocialNetwork(provider, socialAccount[0].id).then(
      () => {
        this.setState({ unboundIsLoading: false });
      }
    );
  }

  render() {
    const { user } = this.props;
    const { unboundIsLoading } = this.state;

    if (!user) {
      return <Redirect to={URLS.authForm} />;
    }

    return (
      <UserSettingsHeader page="userProfile" history={this.props.history}>
        <div className={classNames('backgroundContainer section', styles.userSettingsContainer)}>
          <div className={styles.userSettings}>
            <div className={styles.userSettingsBlocks}>
              <div className={styles.userSettingsColumn}>
                <UserSettingsAvatar user={user} />
                <UserSettingsEmail user={user} />
                <UserSettingsPersonalData user={user} />
              </div>
              <div className={styles.userSettingsColumn}>
                <UserSettingsLitres
                  isLoading={unboundIsLoading}
                  user={user}
                  unbindSocialNetwork={(e, provider) => { this.unbindSocialNetwork(e, provider); }} />
                <UserSettingsSocialNetworks
                  isLoading={unboundIsLoading}
                  user={user}
                  unbindSocialNetwork={(e, provider) => { this.unbindSocialNetwork(e, provider); }} />
              </div>
              <div className={styles.userSettingsColumn}>
                <UserSettingsPassword user={user} />
              </div>
            </div>
          </div>
        </div>
      </UserSettingsHeader>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
    SeoActions: bindActionCreators(SeoActions, dispatch),
    UserActions: bindActionCreators(UserActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsView);
